import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Information from "./pages/Information";
import About from "./pages/About";
import Checkout from "./pages/Checkout";
import Cart from "./pages/Cart";
import ShippingPolicy from "./pages/ShippingPolicy";
import Disclaimers from "./pages/Disclaimers";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Accessibility from "./pages/Accessibility";
import OrderSuccess from "./pages/OrderSuccess";
import { CartProvider } from "./context/CartContext";
import { ProductProvider } from "./context/ProductContext";
import UnderConstruction from "./components/UnderConstruction";
import CartDrawer from "./components/CartDrawer";
import { SITE_SETTINGS } from "./config/siteSettings";

function App() {
  const [showPopup, setShowPopup] = useState(() => {
    if (!SITE_SETTINGS.showUnderConstructionPopup) return false;
    try {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get("popup") === "true") return true;
      if (searchParams.get("popup") === "false") return false;
      return sessionStorage.getItem(SITE_SETTINGS.storageKey) !== "dismissed";
    } catch (e) {
      return true;
    }
  });

  const handleClosePopup = () => {
    try {
      sessionStorage.setItem(SITE_SETTINGS.storageKey, "dismissed");
    } catch (e) {
      // Ignore storage errors
    }
    setShowPopup(false);
  };

  return (
    <ProductProvider>
      <CartProvider>
        <Router>
          <CartDrawer />
          {SITE_SETTINGS.showUnderConstructionPopup && showPopup && (
            <UnderConstruction onClose={handleClosePopup} />
          )}
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              {/* Home & Shop both render the Shop experience */}
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />

              {/* Category Page Routes */}
              <Route path="/stickers" element={<Shop categoryPreselect="Stickers" />} />
              <Route path="/bags" element={<Shop categoryPreselect="Bags" />} />
              <Route path="/keychains" element={<Shop categoryPreselect="Keychains" />} />
              <Route path="/towels" element={<Shop categoryPreselect="Towels" />} />
              <Route path="/enamel-pins" element={<Shop categoryPreselect="Enamel Pins" />} />
              <Route path="/photocard-holders" element={<Shop categoryPreselect="Photocard Holders" />} />
              <Route path="/sanitizer-keychains" element={<Shop categoryPreselect="Sanitizer Keychains" />} />
              <Route path="/collages" element={<Shop categoryPreselect="Collages" />} />
              <Route path="/hand-fans" element={<Shop categoryPreselect="Hand Fans" />} />

              {/* Product & Store Pages */}
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/information" element={<Information />} />
              <Route path="/about" element={<About />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-success" element={<OrderSuccess />} />

              {/* Legal & Policies */}
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="/disclaimers" element={<Disclaimers />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/accessibility" element={<Accessibility />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </CartProvider>
    </ProductProvider>
  );
}

export default App;
